<template>
    <v-container>
        <v-card
            flat
            tile
            class="py-12"
        >
            <v-row justify="center" class="mt-2 mb-6">
                <v-col cols="10" md="8" xl="6" class="bordered text-center">
                    We at Prospira, are committed to continually working torwards a sustainable society 
                    with integrity and in unity with our customers, partners, communities, and the world around us.
                </v-col>
            </v-row>

            <v-row justify="center">
                <v-col cols="10" md="4">
                    <v-card flat color="transparent">
                        <div class="d-flex flex-column align-center">
                            <v-img
                                src="@/assets/icon_harmony.png"
                                aspect-ratio="1"
                                width="175"
                                alt="Cartoon graphic of a green heart"
                            ></v-img>
                        </div>

                        <v-card-title class="d-flex justify-center text-body-1 font-weight-medium green--text text--darken-4">
                            In harmony with nature
                        </v-card-title>
                        <v-card-text class="text-center text-body-2 grey--text text--darken-3">
                            To contribute to biodiversity through habitat enhancement, and through environmental education and research.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="10" md="4">
                    <v-card flat color="transparent">
                        <div class="d-flex flex-column align-center">
                            <v-img
                                src="@/assets/icon_resources.png"
                                aspect-ratio="1"
                                width="175"
                                alt="Cartoon graphic of a green water droplet with a plant in the middle"
                            ></v-img>
                        </div>

                        <v-card-title class="d-flex justify-center text-body-1 font-weight-medium green--text text--darken-4">
                            Value natural resources
                        </v-card-title>
                        <v-card-text class="text-center text-body-2 grey--text text--darken-3">
                            To continually improve natural resource conservation through operational improvements and product design.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="10" md="4">
                    <v-card flat color="transparent">
                        <div class="d-flex flex-column align-center">
                            <v-img
                                src="@/assets/icon_reduce_co2.png"
                                aspect-ratio="1"
                                width="175"
                                alt="Cartoon green graphic depicting CO2 lettering and a downward facing arrow"
                            ></v-img>
                        </div>

                        <v-card-title class="d-flex justify-center text-body-1 font-weight-medium green--text text--darken-4">
                            Reduce CO<sub>2</sub>&nbsp;emissions
                        </v-card-title>
                        <v-card-text class="text-center text-body-2 grey--text text--darken-3">
                            To continually reduce emissions of greenhouse gases, including CO<sub>2</sub>&nbsp;from our products' complete life cycle.
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'EnvironmentPolicy'
}
</script>

<style scoped>
.bordered {
    border-bottom: 1px solid #424242;
    border-top: 1px solid #424242;
}

</style>